<div class="container-fluid">

    <!-- Home Page -->
    <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">

        <div class="carousel-inner">

            <div class="carousel-item active">

                <div id="homePage" style="background: url('assets/images/slide1.jpg'), top center no-repeat;">

                    <div data-aos="zoom-out">

                        <div class="row">

                            <div class="col-lg-6 col-md-10 col-sm-12 col-12 px-lg-5 px-md-5 px-sm-5 px-5 mt-5">

                                <div class="slide-content">

                                    <h1>Custom engineered solutions for <span>Business</span></h1>

                                    <p>Let our team of experienced engineers create a solution for your from our
                                        extensive software libraries and customizable hardware solutions.</p>

                                    <p>Choose one, or combine two or more of our software and hardware modules to create
                                        your own custom solution.</p>

                                    <div class="slide-button">
                                        <a class="button1" href="#" data-toggle="modal" data-target="#exampleModal">Get
                                            Started</a>
                                        <a class="button2" href="#">Learn More</a>
                                    </div>

                                </div>

                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-12"></div>

                        </div>

                    </div>

                </div>

            </div>

            <!-- <div class="carousel-item">

                <div id="homePage" style="background: url('assets/images/slide2.jpg'), top center no-repeat;">

                    <div data-aos="zoom-out">

                        <div class="row">

                            <div class="col-lg-6 col-md-12 col-sm-12 col-12 px-lg-5 px-md-5 px-sm-5 px-5 mt-5">

                                <div class="slide-content">

                                    <h1>Software API Libraries <span>Solutions</span></h1>

                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                        nostrud
                                        exercitation ullamco.</p>

                                    <div class="slide-button">
                                        <a class="button1" href="#" routerLink="/login">Get Started</a>
                                        <a class="button2" href="#">Learn More</a>
                                    </div>

                                </div>

                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-12"></div>

                        </div>

                    </div>

                </div>

            </div>

            <div class="carousel-item">

                <div id="homePage" style="background: url('assets/images/slide2.jpg'), top center no-repeat;">

                    <div data-aos="zoom-out">

                        <div class="row">

                            <div class="col-lg-6 col-md-12 col-sm-12 col-12 px-lg-5 px-md-5 px-sm-5 px-5 mt-5">

                                <div class="slide-content">

                                    <h1> Hardware <span> Solutions </span></h1>

                                    <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                        nostrud
                                        exercitation ullamco. </p>

                                    <div class="slide-button">
                                        <a class="button1" href="#" routerLink="/login"> Get Started </a>
                                        <a class="button2" href="#"> Learn More </a>
                                    </div>

                                </div>

                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-12"></div>

                        </div>

                    </div>

                </div>

            </div> -->

        </div>

    </div>
    <!-- Home Page -->

    <!-- About -->
    <div class="about-section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="section-title left">
                        <h4>Welcome to iTech</h4>
                        <h2>Best Quality IT & Consulting Services</h2>
                        <div class="underline">
                            <div class="br-line"></div>
                        </div>
                        <p>
                            At iTech, we specialize in delivering innovative IT solutions and strategic consulting
                            services that empower businesses to thrive in the digital age. From enterprise software
                            development to cloud integration and IT infrastructure management, our team is dedicated to
                            providing scalable, secure, and result-driven solutions tailored to your needs.
                        </p>
                    </div>
                    <div class="bullet-point-text">
                        <ul>
                            <li><i class="bi bi-check2-circle"></i>End-to-end IT consulting to streamline business
                                processes.</li>
                            <li><i class="bi bi-check2-circle"></i>Custom software, web, and mobile application
                                development.</li>
                            <li><i class="bi bi-check2-circle"></i>Robust cybersecurity solutions to protect digital
                                assets.</li>
                        </ul>
                    </div>
                    <div class="author">
                        <div class="image">
                            <img src="assets/images/author.jpg" alt="">
                        </div>
                        <div class="name">
                            <h4>David Ambrose</h4>
                            <p>CEO & Founder</p>
                        </div>
                        <div class="sign">
                            <img src="assets/images/sign.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="all-img">
                        <div class="bg bg1">
                            <img src="assets/images/about-img1.jpg" alt="">
                        </div>
                        <div class="bg bg2">
                            <img src="assets/images/about-img2.jpg" alt="">
                        </div>
                        <div class="bg3" style="background: url('assets/images/about-img3.jpg');">
                            <span>25</span>
                            <h3>years experience</h3>
                        </div>
                        <div class="shape">
                            <div class="inner"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- About -->


    <!-- Services -->
    <div id="service-section">
        <div class="container">
            <div class="section-title center">
                <h4>Get your Service</h4>
                <h2>Services We are Providing</h2>
                <div class="underline">
                    <div class="br-line"></div>
                </div>
                <p>
                    We deliver a complete range of IT and consulting services designed to help businesses embrace
                    digital transformation and achieve sustainable growth. From strategic technology consulting to
                    cutting-edge software solutions, we provide reliable, secure, and scalable services that meet the
                    unique needs of every client.
                </p>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-3">
                    <div class="service-box">
                        <span class="service-number">01</span>
                        <div class="service-icon">
                            <i class="bi bi-brush"></i>
                        </div>
                        <div class="service-content">
                            <h4>Web Design</h4>
                            <p>Our product design service lets you prototype, test and validate your ideas.</p>
                            <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="service-box">
                        <span class="service-number">02</span>
                        <div class="service-icon">
                            <i class="bi bi-code-slash"></i>
                        </div>
                        <div class="service-content">
                            <h4>Development</h4>
                            <p>Our product design service lets you prototype, test and validate your ideas.</p>
                            <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="service-box">
                        <span class="service-number">03</span>
                        <div class="service-icon">
                            <i class="bi bi-graph-up"></i>
                        </div>
                        <div class="service-content">
                            <h4>Data Analytics</h4>
                            <p>Our product design service lets you prototype, test and validate your ideas.</p>
                            <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="service-box">
                        <span class="service-number">04</span>
                        <div class="service-icon">
                            <i class="bi bi-shield-shaded"></i>
                        </div>
                        <div class="service-content">
                            <h4>Cyber Security</h4>
                            <p>Our product design service lets you prototype, test and validate your ideas.</p>
                            <a href="#" class="service-btn"><i class="bi bi-arrow-right"></i>Learn More</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <!-- Services -->


    <!-- Choose Us -->
    <div id="choose-us">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="image-area">
                        <img src="assets/images/choose-us-img.jpg" alt="">
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="section-title left">
                        <h4>Why Choose Us</h4>
                        <h2>Leading IT & Consulting Service Partner</h2>
                        <div class="underline">
                            <div class="br-line"></div>
                        </div>
                        <p>
                            At iTech, we combine technical expertise, industry knowledge, and innovative strategies to
                            deliver IT and consulting solutions that drive measurable results. Whether it’s software
                            development, cloud migration, digital transformation, or IT infrastructure optimization, we
                            work as your trusted partner to help you achieve your business goals faster and more
                            efficiently.
                        </p>
                    </div>
                    <div class="item-area">
                        <div class="icon-box">
                            <div class="icon">
                                <i class="bi bi-briefcase-fill"></i>
                            </div>
                            <div class="content">
                                <h4>Comprehensive IT Solutions</h4>
                                <p>
                                    From enterprise applications to cloud-based systems, we deliver end-to-end solutions
                                    tailored to your unique business needs, ensuring scalability, security, and
                                    performance.
                                </p>
                            </div>
                        </div>
                        <div class="icon-box">
                            <div class="icon">
                                <i class="bi bi-book-fill"></i>
                            </div>
                            <div class="content">
                                <h4>Experienced & Dedicated Team</h4>
                                <p>
                                    Our skilled professionals bring years of hands-on experience in IT consulting,
                                    development, and project management, working closely with clients to ensure
                                    successful outcomes every time.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Choose Us -->



    <!-- Team Section -->
    <div id="team-section">
        <div class="container">
            <div class="section-title center">
                <h4>Our Team</h4>
                <h2>Meet Our Expert Professionals</h2>
                <div class="underline">
                    <div class="br-line"></div>
                </div>
                <p>
                    At iTech, our strength lies in our people. We bring together a diverse team of skilled IT
                    specialists, business consultants, and creative thinkers who work collaboratively to deliver
                    innovative technology solutions. Each member brings years of expertise, industry knowledge, and a
                    passion for helping businesses grow in a competitive digital world.
                </p>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4">
                    <div class="single-team">
                        <div class="team-inner">
                            <div class="team-image">
                                <img src="assets/images/team01.jpg" alt="Team Member">
                                <div class="social-icons">
                                    <ul>
                                        <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                                        <li><a href="#"><i class="bi bi-twitter"></i></a></li>
                                        <li><a href="#"><i class="bi bi-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="team-content">
                            <div class="team-description">
                                <h4>Stefina Williams</h4>
                                <p>Senior Web Developer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single-team">
                        <div class="team-inner">
                            <div class="team-image">
                                <img src="assets/images/team02.jpg" alt="Team Member">
                                <div class="social-icons">
                                    <ul>
                                        <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                                        <li><a href="#"><i class="bi bi-twitter"></i></a></li>
                                        <li><a href="#"><i class="bi bi-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="team-content">
                            <div class="team-description">
                                <h4>James Carter</h4>
                                <p>IT Solutions Architect</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single-team">
                        <div class="team-inner">
                            <div class="team-image">
                                <img src="assets/images/team03.jpg" alt="Team Member">
                                <div class="social-icons">
                                    <ul>
                                        <li><a href="#"><i class="bi bi-facebook"></i></a></li>
                                        <li><a href="#"><i class="bi bi-twitter"></i></a></li>
                                        <li><a href="#"><i class="bi bi-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="team-content">
                            <div class="team-description">
                                <h4>Linda Martinez</h4>
                                <p>Business Technology Consultant</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Team Section -->




    <!-- Call-to-Action -->
    <div id="call-to-action" style="background: url('assets/images/about-img3.jpg');">
        <div class="main-area">
            <div class="container">
                <div class="video">
                    <div class="video-icon">
                        <a href="#"><i class="bi bi-play-circle"></i></a>
                    </div>
                    <h4>Some Interecting Facts About Us</h4>
                </div>
                <div class="counter-area">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">
                            <div class="counter-wrapper">
                                <span class="counter">34763</span><span>+</span>
                                <h5>Happy Clients</h5>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <div class="counter-wrapper">
                                <span class="counter">200</span><span>+</span>
                                <h5>Complete Project</h5>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <div class="counter-wrapper">
                                <span class="counter">34763</span><span>+</span>
                                <h5>Cup of Tea</h5>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <div class="counter-wrapper">
                                <span class="counter">100</span><span>+</span>
                                <h5>Awards</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-area">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-4">
                        <div class="form-title">
                            <h4>Request to Call back</h4>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <form method="post" action="request-form-handler.php">
                            <input class="input-field" type="text" name="name" placeholder="Your name">
                            <input class="input-field" type="email" name="email" placeholder="Your email">
                            <input class="message-field" type="text" name="message" placeholder="Message">
                            <button type="submit">Send</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- Call-to-Action -->



    <!-- Case-Studies -->
    <div id="case-studies">
        <div class="container">
            <div class="section-title center">
                <h4>Case Studies</h4>
                <h2>Our Latest Projects</h2>
                <div class="underline">
                    <div class="br-line"></div>
                </div>
                <p>
                    Discover how our IT and consulting expertise has helped businesses transform their operations,
                    enhance efficiency, and achieve sustainable growth. From enterprise software solutions to advanced
                    digital transformation strategies, each project reflects our commitment to innovation, quality, and
                    measurable results.
                </p>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 order-lg-1 order-md-1">
                    <div class="item one">
                        <img src="assets/images/case01.jpg" alt="">
                        <div class="action">
                            <span>Enterprise Software</span>
                            <h4>Custom ERP Development for Manufacturing Firm</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 order-lg-2 order-md-2 mt-sm-30">
                    <div class="item two">
                        <img src="assets/images/case02.jpg" alt="">
                        <div class="action">
                            <span>Cloud Solutions</span>
                            <h4>Cloud Migration & Optimization for Retail Chain</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 order-lg-3 order-md-3 mt-md-30 mt-sm-30">
                    <div class="item three">
                        <img src="assets/images/case03.jpg" alt="">
                        <div class="action">
                            <span>IT Infrastructure</span>
                            <h4>Network Security Upgrade for Financial Services</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-8 col-md-12 order-lg-4 order-md-5">
                    <div class="item four">
                        <img src="assets/images/case04.jpg" alt="">
                        <div class="action">
                            <span>Digital Transformation</span>
                            <h4>E-Commerce Platform Modernization for Global Brand</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 order-lg-5 order-md-4">
                    <div class="item five">
                        <img src="assets/images/case05.jpg" alt="">
                        <div class="action">
                            <span>Mobile Development</span>
                            <h4>Cross-Platform App for Logistics Management</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 order-lg-6 order-md-6">
                    <div class="item six">
                        <img src="assets/images/case06.jpg" alt="">
                        <div class="action">
                            <span>Data Analytics</span>
                            <h4>Real-Time Business Intelligence Dashboard</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 order-lg-7 order-md-7">
                    <div class="item six">
                        <img src="assets/images/case07.jpg" alt="">
                        <div class="action">
                            <span>Consulting</span>
                            <h4>IT Strategy & Process Optimization for SMEs</h4>
                            <a href="#"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Case-Studies -->




    <!-- Testimonial -->
    <div id="testimonial" style="background: url('assets/images/testimonial-bg.jpg');">

        <div class="container">

            <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">

                <div class="carousel-inner">

                    <div class="testimonial-carousel owl-carousel">

                        <div class="carousel-item active">

                            <div class="testimonial-wrapper">

                                <div class="image">
                                    <img src="assets/images/avatar-1.jpg" alt="">
                                </div>
                                <div class="quote">
                                    <p>
                                        "iTech has been an incredible partner in transforming our IT infrastructure.
                                        Their team delivered a secure and scalable solution that improved our efficiency
                                        and reduced downtime significantly."
                                    </p>
                                </div>
                                <div class="name">
                                    <h4>Siobhán McFeeney</h4>
                                    <p>CEO, GlobalTech Solutions</p>
                                </div>

                            </div>

                        </div>


                        <div class="carousel-item">

                            <div class="testimonial-wrapper">

                                <div class="image">
                                    <img src="assets/images/avatar-2.jpg" alt="">
                                </div>
                                <div class="quote">
                                    <p>
                                        "From strategic IT consulting to flawless implementation, iTech exceeded our
                                        expectations. Their expertise in cloud migration helped us achieve seamless
                                        integration with zero disruption."
                                    </p>
                                </div>
                                <div class="name">
                                    <h4>Angela Hammack</h4>
                                    <p>Managing Director, Innovate Corp</p>
                                </div>

                            </div>

                        </div>

                        <div class="carousel-item">

                            <div class="testimonial-wrapper">

                                <div class="image">
                                    <img src="assets/images/avatar-3.jpg" alt="">
                                </div>
                                <div class="quote">
                                    <p>
                                        "The iTech team is highly professional, responsive, and innovative. Their
                                        tailored software solutions have streamlined our operations and given us a
                                        competitive edge in our industry."
                                    </p>
                                </div>
                                <div class="name">
                                    <h4>Cristiano Ronaldo</h4>
                                    <p>Founder, Digital Vision Ltd</p>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
    <!-- Testimonial -->




    <!-- Blog -->
    <div id="blog" class="style1">
        <div class="container">
            <div class="section-title style-two left">
                <div class="text-wrapper">
                    <h4>Blog</h4>
                    <h2>Latest Insights & Industry Updates</h2>
                    <div class="underline">
                        <div class="br-line"></div>
                    </div>
                    <p>
                        Stay ahead with iTech’s expert articles covering the latest trends in IT solutions, digital
                        transformation, cloud computing, cybersecurity, and business technology strategies. Our goal is
                        to help you make informed decisions for sustainable growth.
                    </p>
                </div>
                <div class="button">
                    <a href="#">See All Posts</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-4">
                    <div class="single-blog">
                        <div class="thumb">
                            <a href="#"><img src="assets/images/blog-01.jpg" alt=""></a>
                        </div>
                        <div class="content">
                            <div class="meta">
                                <ul>
                                    <li>By <a href="#">iTech</a></li>
                                    <li>January 01, 2021</li>
                                    <li class="share"><a href="#"><i class="bi bi-share-fill"></i></a></li>
                                </ul>
                            </div>
                            <div class="title">
                                <h3>How Digital Transformation Can Boost Your Business</h3>
                            </div>
                            <div class="description">
                                <p>
                                    Discover how adopting modern IT solutions and automation can streamline operations,
                                    improve efficiency, and drive business growth in today’s competitive market.
                                </p>
                            </div>
                            <div class="button">
                                <a href="#"><i class="bi bi-arrow-right"></i>Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single-blog">
                        <div class="thumb">
                            <a href="#"><img src="assets/images/blog-02.jpg" alt=""></a>
                        </div>
                        <div class="content">
                            <div class="meta">
                                <ul>
                                    <li>By <a href="#">iTech</a></li>
                                    <li>January 10, 2021</li>
                                    <li class="share"><a href="#"><i class="bi bi-share-fill"></i></a></li>
                                </ul>
                            </div>
                            <div class="title">
                                <h3>Top 5 IT Consulting Strategies for 2021</h3>
                            </div>
                            <div class="description">
                                <p>
                                    From cloud migration to AI integration, explore the most effective IT consulting
                                    practices that can future-proof your organization in the digital era.
                                </p>
                            </div>
                            <div class="button">
                                <a href="#"><i class="bi bi-arrow-right"></i>Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4">
                    <div class="single-blog">
                        <div class="thumb">
                            <a href="#"><img src="assets/images/blog-03.jpg" alt=""></a>
                        </div>
                        <div class="content">
                            <div class="meta">
                                <ul>
                                    <li>By <a href="#">iTech</a></li>
                                    <li>January 20, 2021</li>
                                    <li class="share"><a href="#"><i class="bi bi-share-fill"></i></a></li>
                                </ul>
                            </div>
                            <div class="title">
                                <h3>Cybersecurity Best Practices for Businesses</h3>
                            </div>
                            <div class="description">
                                <p>
                                    Learn how to protect your company’s data and digital assets with advanced security
                                    measures, employee awareness, and proactive risk management.
                                </p>
                            </div>
                            <div class="button">
                                <a href="#"><i class="bi bi-arrow-right"></i>Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Blog -->





    <!-- Footer -->
    <footer id="footer">

        <div class="container">

            <div class="row">

                <div class="col-md-6 col-lg-3">

                    <div class="about">

                        <img class="logo" src="assets/icons/Transparent-2.png" alt="">

                        <p>There are many variations of passages of Lorem Ipsum available, but the majority have
                            suffered alteration in some form, by injected.</p>

                        <div class="social-icon">
                            <a href="#"><i class="bi bi-facebook"></i></a>
                            <a href="#"><i class="bi bi-twitter"></i></a>
                            <a href="#"><i class="bi bi-instagram"></i></a>
                        </div>

                    </div>

                </div>

                <div class="col-md-6 col-lg-3">

                    <div class="quick-link">

                        <h4>Quick Link</h4>
                        <ul>
                            <li><a href="#">Product Design</a></li>

                            <li><a href="#">Application Development</a></li>
                            <li><a href="#">Cyber Security</a></li>
                            <li><a href="#">Data Quality Management</a></li>
                            <li><a href="#">IT Counsultancy</a></li>
                            <li><a href="#">Mobile Development</a></li>
                            <li><a href="#">Cloud Migration</a></li>
                        </ul>

                    </div>

                </div>


                <div class="col-md-6 col-lg-3">

                    <div class="address">
                        <h4>Our Address</h4>
                        <img src="assets/images/img-footer-map.png" alt="">
                        <p><i class="bi bi-geo-alt-fill"></i><span>91 Western Road, Brighton, England</span></p>
                    </div>

                </div>

                <div class="col-md-6 col-lg-3">

                    <div class="contact">

                        <h4>Contact Us</h4>

                        <div class="phone">
                            <p><i class="bi bi-telephone-fill"></i><span>+44 1632 960896</span></p>
                        </div>

                        <div class="email">
                            <p><i class="bi bi-envelope-fill"></i> info@securityrelated.com</p>
                        </div>
                        <div class="subscribe">
                            <p>Subscribe to our Newsletter</p>
                            <form action="#">
                                <input type="text" placeholder="Your email">
                                <button type="submit"><i class="bi bi-arrow-right"></i></button>
                            </form>
                        </div>


                    </div>

                </div>

            </div>

            <div class="copyright">

                <div class="left">
                    <p>Copyright © 2022 Security Related Inc. All rights reserved.</p>
                </div>

                <div class="copyright-menu">

                    <ul>
                        <li><a href="#">Terms & Condition</a></li>
                        <li><a href="#">Privacy Policy</a></li>
                        <li><a href="#">Contact Us</a></li>
                    </ul>

                </div>

            </div>

        </div>

    </footer>
    <!-- Footer -->


</div>